import React from "react";
import { Fragment } from "react";
import Footer from "../../components/footer/Footer";
import Links from "../../components/links/Links";

export const PrivacyPage = () => {
  return (
    <Fragment>
      <div className="faq-container">
        <h1>Privacy Policy of THRILLER</h1>
        <div className="question-container">
          <div className="question">
            <p>
              Our privacy policy describes the ways in which we collect, store,
              discloses and transfers, use, and protect user’s information
              through our Platform and application, including through
              THRILLER.com, and online services (collectively, the "Platform)
              and it is important for you to review this privacy policy. By
              "User information" we mean information that can be associated with
              a specific person that can be used to identify that person.
              THRILLER committed to establishing a trustworthy and secure online
              platform for you, we take the safeguard of your data genuinely and
              firmly about protecting your privacy. We understand how valuable
              privacy is to you, and we are committed to creating a reliable and
              secure environment for Users of all ages. We use the data we
              collect to provide you with a better experience and fulfill our
              objective of providing a smooth and transparent platform for
              E-commerce.
            </p>
          </div>
          <div className="question">
            <p>
              THRILLER is an electronic web-based E-commerce Marketplace
              platform for providing registered Seller certain services to
              facilitate the marketing, sale their products, good and services
              by Seller to its customers (Buyer), platform is an online platform
              that enables you to purchase products listed on the website at the
              price indicated therein at any time from any location. You agree
              and acknowledge that THRILLER is only a facilitator.
            </p>
          </div>

          <div className="question">
            <p>
              We collect User’s information from you when you use THRILLER and
              when you sign up as a User to use a service, we collect more
              specific personal information about you, such as your name,
              address, email address, telephone, mobile number, etc. by
              providing us with your information you expressly consent to us
              processing your information in accordance with the terms of our
              privacy policy. We do not collect sensitive personal data or
              information of users like the password of your email account.
            </p>
          </div>
          <div className="question">
            <p>
              We may amend our privacy policy at any time by posting a revised
              version on the Website. The revised version will be effective at
              the time we post it and, following such posting, your continued
              use of the Site will constitute your express consent to us
              continuing to process you or your business entity information in
              accordance with the terms of our revised privacy policy. We would
              encourage you to check the Site regularly for the announcement of
              any amendments to our privacy policy. By visiting this Website,
              you agree to be bound by the terms and conditions of this Privacy
              Policy. If you do not agree please do not use or access our
              Platform, or any kind of our Service.
            </p>
          </div>
          <div className="question">
            <p>
              When buying an item through the Service, you agree to our rules
              and policies for Buyers described in our FAQ, which can be found
              at www.Thriller.com/faq, as well as our return policy also
              mentioned at www.thrillerme.com/faq. You further agree that you
              are responsible for reading the full item listing before making a
              decision to purchase an item. As a buyer, you are obligated to pay
              for any items you Bid on when your Bid matches a seller’s Ask.
              WHEN YOU PLACE A BID, YOU ARE COMMITTING TO PURCHASE THE ITEM AS
              SOON AS YOUR BID MATCHES A SELLER’S ASK PRICE AND YOU ACKNOWLEDGE
              THAT PAYMENT OF THE ASK PRICE WILL BE TAKEN FROM YOUR PAYMENT
              METHOD. To be an eligible buyer you must have a billing address
              and shipping address within the United Arab
            </p>
          </div>
          <div className="question">
            <p>
              Our Platform links to other websites that may collect personally
              identifiable information about you, THRILLER is not responsible
              for the privacy practices or the content of those linked websites.
            </p>
          </div>
          <div className="question">
            <p>
              Our Platform has stringent security measures in place to protect
              the loss, misuse, and alteration of the information under our
              control. Whenever you change or access your account information,
              we offer the use of a secure server. Once your information is in
              our possession, we adhere to strict security guidelines,
              protecting it against unauthorized access.
            </p>
          </div>
          <div className="question">
            <p>
              By using the Platform and/ or by providing your information, you
              consent to the collection and use of the information you disclose
              on the Platform in accordance with this Privacy Policy, including
              but not limited to your consent for sharing your information as
              per this privacy policy and you also read and agree Users Terms.
            </p>
          </div>
          <div className="question">
            <p>
              In transaction or applying for THRILLER payment or buying a
              service from our platform, your personal details and credit/ debit
              card information are secure using security features of internet
              security. However, we cannot guarantee encryption or the privacy
              of your personal details and credit/debit card information. When
              we receive your order, it is kept encrypted until we are ready to
              process it.
            </p>
          </div>
          <div className="question">
            <p>
              These Terms constitute the entire and exclusive understanding and
              agreement between you and GOAT regarding the Service and
              Collective Content, and these Terms supersede and replace any and
              all prior oral or written understandings or agreements between you
              and GOAT regarding the Service and Collective Content.
            </p>
          </div>

          <div className="question">
            <h5>DISCLOSURE OF YOUR INFORMATION</h5>
            <p>
              We may disclose your information that we collect, or you provide
              as described in this Privacy Policy:
            </p>

            <span>You must not:</span>

            <ul>
              <li>
                <p>
                  . By registering or purchasing you as Buyer providing your
                  contact information, you consent to the disclosure of your
                  information to associate Service providers (Seller, Delivery
                  Partner) and to be contacted by such service providers to
                  provide services.
                </p>
              </li>
              <li>
                <p>
                  · To our subsidiaries, affiliates, contractors, service
                  providers, and other third parties we use to support our
                  business. We supply your contact information to select third
                  parties such as data aggregators, marketers, or others for the
                  purpose of sending you e-mail or otherwise communicating with
                  you. We use data we have about you to determine whether you
                  might be interested in the products, or services of a
                  particular third party.
                </p>
              </li>
              <li>
                <p>
                  · To a service provider or other successor in the event of a
                  merger, divestiture, restructuring, reorganization,
                  dissolution or other sale or transfer of some or all of the
                  Company's assets, whether as a going concern or as part of
                  bankruptcy, liquidation, or similar proceeding, in which
                  personal information held by the Company about our Website
                  users is among the assets transferred.
                </p>
              </li>
              <li>
                <p>
                  · To comply with any court order, law, or legal process,
                  including responding to any government or regulatory request.
                </p>
              </li>
              <li>
                <p>
                  · To enforce or apply our terms of use or terms of service and
                  other agreements, including for billing and collection
                  purposes.
                </p>
              </li>
              <li>
                <p>
                  · If we believe disclosure is necessary or appropriate to
                  protect the rights, property, or safety of the Company, our
                  users, or others. This includes exchanging information with
                  other companies and organizations for the purposes of fraud
                  protection and credit risk reduction.
                </p>
              </li>
            </ul>
          </div>

          <div className="question">
            <h5>Our collection of your information</h5>

            <ul>
              <li>
                <p>
                  · As part of your registration on the Site, you will be asked
                  to provide us with certain information, such as name, address,
                  email address, and/or telephone number, photo, and other
                  similar information as well as some additional information
                  about you such identifying information.
                </p>
              </li>
              <li>
                <p>
                  · We will collect transactional information based on your
                  activities using the Site (such as the use of services); this
                  transactional information is used solely in relation to the
                  transactions you undertake on the Site and for no other
                  reasons.
                </p>
              </li>
              <li>
                <p>
                  · Please note that we may use your Internet protocol (or IP)
                  address (which is a unique number assigned to your computer
                  server or your Internet service provider (or ISP)) to evaluate
                  user trends and improve the administration of the Site.
                </p>
              </li>
              <li>
                <p>
                  · We may also collect information about your computer (for
                  example, browser type) and navigation information (for
                  example, the pages you visit on the Site) along with the times
                  that you access the Site. Finally, we may collect additional
                  information from or about you in other ways not specifically
                  described here. For example, we may collect information
                  related to your contact with our customer support team or
                  store results when you respond to a survey. We may also
                  collect feedback ratings and other comments relating to your
                  use of the THRILLER.
                </p>
              </li>
              <li>
                <p>
                  · We may automatically track certain information about you
                  based upon your behavior on our Website. We use this
                  information to do internal research on our users'
                  demographics, interests, and behavior to better understand,
                  protect and serve our users. This information is compiled and
                  analyzed on an aggregated basis
                </p>
              </li>
            </ul>
          </div>

          <div className="question">
            <p>
              We use 'cookie' technology (small computer files placed on your
              computer’s hard drive). When you go to particular website pages on
              the Site, the cookie identifies your browser with a unique, random
              number. The cookies we use do not reveal any information about
              you.
            </p>
          </div>
          <div className="question">
            <p>
              By registering on the Site, you give us your express consent to
              receive promotional emails about our services and emails
              announcing changes to, and new features on, the Site, If, at any
              time.
            </p>
          </div>

          <div className="question">
            <p>
              You may not use our communication tools to send spam or otherwise
              send content that would violate our User Agreement. Protecting
              your information THRILLER holds your information on servers. By
              providing us with your information, you consent to the transfer of
              your information to, and its storage on, our servers. We take
              every precaution to safeguard all your information from
              unauthorized access, use or disclosure. However, the Internet is
              not a secure medium and we cannot guarantee the privacy of your
              information. You must enter your username and password each time
              you want to access your account or make transactions on the Site.
              Choose your password carefully using unique numbers, letters, and
              special characters. Never share your username and password with
              anyone. If you are concerned that your username or password has
              been compromised, please contact us immediately and ensure you
              change your password by logging onto the User Account section of
              the THRILLER.
            </p>
          </div>

          <div className="question">
            <p>
              You Consent By using the platform and/ or by providing your
              information, you consent to the collection and use of the
              information you disclose on the Website in accordance with this
              Privacy Policy, including but not limited to Your consent for
              sharing your information as per this privacy policy. If you
              disclose any personal information relating to other people to us,
              you represent that you have the authority to do so and to permit
              us to use the information in accordance with this Privacy Policy.
            </p>
          </div>

          <div className="question">
            <h5>Contact Us</h5>
            <p>
              If there are any questions regarding this privacy policy, you may
              contact us using the information below. Email:{" "}
              <a href="mailto:info@THRILLER.com">info@THRILLER.com</a>
            </p>
          </div>
        </div>
      </div>
      <Links />
      <Footer />
    </Fragment>
  );
};
